import { Component, OnInit, Input, forwardRef, KeyValueDiffers } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-jabil-text-area',
  templateUrl: './jabil-text-area.component.html',
  styleUrls: ['./jabil-text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JabilTextAreaComponent),
      multi: true
    }
  ]
})
export class JabilTextAreaComponent implements OnInit,  ControlValueAccessor {
  @Input() caption: string;
  @Input() nameControl: string;
  @Input() placeholder: string;
  @Input() type: string = "text";
  value: any;
  @Input() isReadOnly: boolean = false;
  isDisabled: boolean;
  onChange = (_: any) => { }
  onTouch = () => { }

  constructor() { 
    //This is intentional.
  }

  ngOnInit(): void {
    //This is intentional.
  }

  onInput(value: any) {
    this.value = value;
    this.onTouch();
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value || '';
    } else {
      this.value = '';
    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }
  setDisabledState(isDisabled: boolean): void { this.isDisabled = isDisabled; }

}
